import { useMemo } from 'react';
import { getAppPermissions } from 'shared/utility';

export function usePermissions(claims: string = '') {
  return useMemo(() => getAppPermissions(claims), [claims]);
}
